import { SubContentProps } from '../../LanguageSetting';
import { useEmailSignatureData, useSignatureData } from '@/hooks/apiHooks';
import { useCallback, useEffect } from 'react';
import { MailSignatureLink } from './constants';
import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { useSnackbar } from '@/hooks/global-tools';
import { useTranslation } from 'react-i18next';

const useMailSignatureProps = (props: SubContentProps) => {
  const { t } = useTranslation();
  const { data, error } = useEmailSignatureData();
  const { showSuccess, showError } = useSnackbar();

  const { employeeNumber } = useAtomValue(MyInfoState);
  const { data: signData, error: signError } = useSignatureData(employeeNumber);

  const copyMailSignature = useCallback((id: string) => {
    const temp = document.getElementById(id);

    if (temp) {
      const range = document.createRange();
      range.selectNode(temp);

      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);

      try {
        const success = document.execCommand('copy');
        if (!success) {
          showError({
            message: t('복사에 실패했어요.'),
            duration: 1000,
          });

          return;
        }

        showSuccess({
          message: t('복사가 완료되었어요.'),
          duration: 1000,
        });
      } catch (err) {
        showError({
          message: t('복사에 실패했어요.'),
          duration: 1000,
        });
      }

      selection?.removeAllRanges();
    }
  }, []);

  useEffect(() => {
    if (error) {
      showError({
        message: `${t('MYPAGE.서명 정보를 가져오는데 실패했어요.')}\n${
          error.message
        }`,
      });
    } else if (signError) {
      showError({
        message: `${t('MYPAGE.서명 정보를 가져오는데 실패했어요.')}\n${
          signError.message
        }`,
      });
    }
  }, [error, signError]);

  return {
    data:
      data && signData
        ? {
            ...data,
            insidePhone: signData.insidePhone,
          }
        : undefined,
    copyMailSignature,
    mailLink: MailSignatureLink,
  };
};

export default useMailSignatureProps;
